module.exports = __webpack_public_path__ + "static/media/Gong.c5689895.jpg";